import React from 'react';
import Helmet from 'react-helmet';
import './notFoundPage.scss';

const NotFound = () => {
    return (
        <main>
            <Helmet>
                <meta name="robots" content="noindex" />
                <title>Siden ikke funnet</title>
            </Helmet>
            <h1>Oj, denne siden eksisterer ikke lengre... </h1>
            <p className="not-found-hint">
                Kanskje du ser etter en av mine{' '}
                <a href="/prosjekter/">prosjekter?</a>
            </p>
        </main>
    );
};

export default NotFound;
